// TODO: implement validation for card fields

import * as Yup from "yup";
import { validationSchemaAddress } from "../FormPartialAddress";
import { getValidationSchemaBankCard } from "../FormPartialBankCard";

export const validationSchema = Yup.object().shape({
  address: validationSchemaAddress,
  card: getValidationSchemaBankCard()
});
